import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/shape-20.png'
import _imports_1 from '@/assets/images/shape-21.png'


const _hoisted_1 = { class: "page-banner-area bg-secondary" }
const _hoisted_2 = { class: "container mw-1720" }
const _hoisted_3 = { class: "page-banner-content" }
const _hoisted_4 = { class: "d-flex align-items-center ps-0 list-unstyled bredcrounbs" }
const _hoisted_5 = { class: "container mw-1356" }
const _hoisted_6 = {
  key: 0,
  class: "table-responsive cart-table"
}
const _hoisted_7 = { class: "table align-middle mb-0" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "ps-0" }
const _hoisted_10 = { class: "price" }
const _hoisted_11 = { class: "product-quantity" }
const _hoisted_12 = { class: "add-to-cart-counter d-flex align-items-center justify-content-between" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "price" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 1,
  class: "text-center mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", null, [
            _createVNode(_component_RouterLink, { to: "/" }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode(" HOME ", -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("li", null, [
            _createElementVNode("span", null, "SHOP")
          ], -1)),
          _cache[2] || (_cache[2] = _createElementVNode("li", null, [
            _createElementVNode("span", null, "CART")
          ], -1))
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("h2", null, "Check your cart", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.cartStore.cart.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _cache[5] || (_cache[5] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "Product"),
                  _createElementVNode("th", { scope: "col" }),
                  _createElementVNode("th", { scope: "col" }, "Price"),
                  _createElementVNode("th", { scope: "col" }, "Quantity"),
                  _createElementVNode("th", { scope: "col" }, "Subtotal"),
                  _createElementVNode("th", { scope: "col" }, "Remove")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cartStore.cart, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id
                  }, [
                    _createElementVNode("td", null, [
                      _createVNode(_component_RouterLink, { to: "/product-details" }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: item.image,
                            class: "cart-product",
                            alt: item.name
                          }, null, 8, _hoisted_8)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _createElementVNode("td", _hoisted_9, [
                      _createVNode(_component_RouterLink, {
                        to: "/product-details",
                        class: "title"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_10, "$" + _toDisplayString(item.price), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("input", {
                            type: "button",
                            class: "minusBtn",
                            value: "-",
                            onClick: ($event: any) => (_ctx.decreaseQuantity(index))
                          }, null, 8, _hoisted_13),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            size: "25",
                            class: "count",
                            "onUpdate:modelValue": ($event: any) => ((item.quantity) = $event)
                          }, null, 8, _hoisted_14), [
                            [_vModelText, item.quantity]
                          ]),
                          _createElementVNode("input", {
                            type: "button",
                            class: "plusBtn",
                            value: "+",
                            onClick: ($event: any) => (_ctx.increaseQuantity(index))
                          }, null, 8, _hoisted_15)
                        ])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_16, " $" + _toDisplayString(item.price * (item.quantity || 0)), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        class: "border-0 p-0 bg-transparent remove",
                        onClick: ($event: any) => (_ctx.cartStore.removeFromCart(item.id))
                      }, [...(_cache[4] || (_cache[4] = [
                        _createElementVNode("i", { class: "ri-delete-bin-line" }, null, -1)
                      ]))], 8, _hoisted_17)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_18, "Your cart is empty."))
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("img", {
      src: _imports_0,
      class: "shape-21 shape",
      alt: "shape"
    }, null, -1)),
    _cache[7] || (_cache[7] = _createElementVNode("img", {
      src: _imports_1,
      class: "shape-22 shape",
      alt: "shape"
    }, null, -1))
  ]))
}